<template>
  <div class="main">
    <!-- 国家税务局电子税务局首页 -->

    <div class="tax-wrap">
      <header class="tax-header">
        <img class="logo" src="https://static.rhkj.com/renhe_fe/other/351.png">

        <div class="nav-content">
          <img class="nav" src="https://static.rhkj.com/renhe_fe/other/352.png">
          <img class="login-bt"
               @click="goLoginPage"
               src="https://static.rhkj.com/renhe_fe/other/353.png">
        </div>
      </header>
    </div>


    <main class="content">
      <div class="main-bg" @click="goLoginPage">
        <img class="main-bg-img"
             src="https://static.rhkj.com/renhe_fe/other/354.jpg"
        />
        <div class="header-mid-content">
          <img src="https://static.rhkj.com/renhe_fe/other/355.png" alt="" class="text1Img">
          <img src="https://static.rhkj.com/renhe_fe/other/356.png" alt="" class="text2Img">
        </div>
      </div>

      <div class="tip-txt">
        <div class="tip-wrap">
          <span class="bold">办税日历</span>：6月征期已结束，请关注下月征期
        </div>
      </div>

      <div class="function">
        <img src="https://static.rhkj.com/renhe_fe/other/357.png"/>
      </div>
    </main>

    <div class="foot1">
      <img src="https://static.rhkj.com/renhe_fe/other/360.png"/>
    </div>

    <div class="foot2">
      <div class="foot-wrap">
        <img src="https://static.rhkj.com/renhe_fe/other/361.png"/>
      </div>
    </div>
  </div>
</template>

<script setup name="StateTax/home">
const emits = defineEmits(['changePage']);

//跳转至登录页面
function goLoginPage() {
  emits('changePage', 'login');
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }


  .tax-wrap {
    height: 56px;

    .tax-header {
      background-color: #4487f2;
      height: 56px;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 10;

      .logo {
        position: absolute;
        left: 20px;
        top: 0;
      }

      .nav-content {
        display: flex;
        margin: 0 auto;
        justify-content: flex-end;
        align-items: center;
        width: 1084px;

        .login-bt {
          width: 85px;
          height: 42px;
          cursor: pointer;
        }
      }
    }
  }


  .content {
    background-color: #f7f8fa;

    .main-bg {
      height: 596px;
      position: relative;

      .main-bg-img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }

      .header-mid-content {
        position: absolute;
        top: 0;
        left: calc(50% - 592px);
        z-index: 1;
        width: 1184px;
        height: 596px;

        .text1Img {
          position: absolute;
          bottom: 335px;
          width: 300px;
          height: 60px;
        }

        .text2Img {
          position: absolute;
          bottom: 254px;
          left: 157px;
          width: 300px;
          height: 60px;
        }
      }
    }

    .tip-txt {
      background-color: #f1f2f3;
      width: 100%;

      .tip-wrap {
        width: 1184px;
        margin: auto;
        line-height: 50px;
        font-size: 14px;
        font-weight: 400;

        .bold {
          font-weight: 700;
        }
      }
    }

    .function {
      width: 1184px;
      margin: auto;
    }
  }

  .foot1 {
    background-color: #FFFFFF;

    > img {
      width: 1184px;
      margin: auto;
      display: block;
    }
  }

  .foot2 {
    background-color: #e4e4e4;

    .foot-wrap {
      padding: 2px 0;
      width: 1184px;
      margin: auto;
    }
  }
}
</style>
